@if (showLoader()) {
  <section class="loaderwrp">
    <div class="scale-loader">
      <div class="dot-pulse"></div>
    </div>
  </section>
}
<app-header></app-header>
<div class="container relative btm-img-pad">
  <div class="inner-content-wrap py24-700">
    <div class="registration">
      <div class="common-head mb44 mb28-700 px24-700">
        <h1 class="farro-header mb8">{{formHeading}}</h1>
        @if (isExistingUser !== 'true' && (currentNumber === 1 || currentNumber === 2 || currentNumber === 3)) {
          <p class="mb16">{{numberOfQuestions}}</p>
        }
        @if (isExistingUser === 'true' && messageBoxopen && currentNumber !== 4) {
          <div class="warning-info flex items-center gap16 mb44 mb28-700">
            <img src="assets/icons/warning-icon.svg" alt="existing user message" class="info-icon" />
            <p class="warning-info-text flex-1">{{existingUserMessageText}}</p>
            <img src="assets/icons/warning-close.svg" alt="close" class="cursor-pointer" style="flex-shrink: 0;" (click)="messageBox()" />
          </div>
        }
      </div>
    </div>
    <div class="stepper-wrapper">
      <div class="stepper-line"></div>
      <div class="stepper-line-active" [style.width]="((currentNumber - 1) * 25) + '%'"></div>
      <div class="stepper flex">
        <div class="step flex flex-column items-center gap4"
          [ngClass]="{'active':currentNumber==1, 'completed':highestCompletedStep >= 1 && currentNumber!=1 && 1 < currentNumber}">
          <button class="step-circle flex items-center justify-center cursor-pointer" (click)="clickedReview(1)">
            <p class="step-number font-bold">1</p>
          </button>
          <p class="step-label font-bold">{{personalDetailsText}}</p>
        </div>
        <div class="step flex flex-column items-center gap4"
          [ngClass]="{'active':currentNumber==2, 'completed': highestCompletedStep >= 2 && currentNumber!=2 && 2 < currentNumber}">
          <button class="step-circle flex items-center justify-center cursor-pointer" (click)="clickedReview(2)">
            <p class="step-number font-bold">2</p>
          </button>
          <p class="step-label font-bold">{{academicDetailsText}}</p>
        </div>
        <div class="step flex flex-column items-center gap4"
          [ngClass]="{'active':currentNumber==3, 'completed': highestCompletedStep >= 3 && currentNumber!=3 && 3 < currentNumber}">
          <button class="step-circle flex items-center justify-center cursor-pointer" (click)="clickedReview(3)">
            <p class="step-number font-bold">3</p>
          </button>
          <p class="step-label font-bold">{{englishProficiencyText}}</p>
        </div>
        <div class="step flex flex-column items-center gap4"
          [ngClass]="{'active':currentNumber==4, 'completed': highestCompletedStep >= 4 && currentNumber!=4 && 4 < currentNumber}">
          <button class="step-circle flex items-center justify-center cursor-pointer" (click)="clickedReview(4)">
            <p class="step-number font-bold">4</p>
          </button>
          <p class="step-label font-bold">{{reviewDetailsText}}</p>
        </div>
      </div>
    </div>
    @if (currentNumber === 1) {
      <div>
        <p class="mb28 page-header farro-header text-center">{{personalDetailsText}}</p>
        <app-personal-details (nextClicked)="onPersonalDetailsNext()" (existingUserChecked)="onExistingUserChecked($event)"></app-personal-details>
      </div>
    }

    @if (currentNumber === 2) {
      <div>
        <p class="mb28 page-header farro-header text-center">{{academicDetailsText}}</p>
        <app-academic-details
          (nextClicked)="onAcademicDetailsNext()"
          (backClicked)="onAcademicDetailsBack()"
          (dataLoaded)="onAcademicDataLoaded()">
        </app-academic-details>
      </div>
    }

    @if (currentNumber === 3) {
      <div>
        <p class="mb28 page-header farro-header text-center">{{englishProficiencyText}}</p>
        <app-english-proficiency
          (nextClicked)="onEnglishProficiencyNext()"
          (backClicked)="onEnglishProficiencyBack()">
        </app-english-proficiency>
      </div>
    }

    @if (currentNumber === 4) {
      <div>
        <p class="mb28 page-header farro-header text-center">{{reviewDetailsText}}</p>
        <app-review-details (backClicked)="onReviewDetailsBack()" (navigateToStep)="navigateAndValidate($event)"></app-review-details>
      </div>
    }
  </div>
</div>
